export {default} from '../../../core/components/AppMenu/AppMenuItemRouteTabs';
